import React from 'react';
import { graphql } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import SanityPortableText from '../SanityPortableText';

import Pancake from './Pancake';
import Card from '../Card';

import 'swiper/css';
import './FeaturesHighlight.scss';

const FeaturesHighlight = (props) => {
  const { features, highlights, theme } = props;

  return (
    <Pancake className="FeaturesHighlight" theme={theme} /* key={cardTitle} */>
      <div className="FeaturesHighlightGrid">
        <div className="FeaturesHighlightList">
          <SanityPortableText blocks={features} />
        </div>
        {highlights?.length > 0 && (
          <>
            <Swiper
              spaceBetween={25}
              slidesPerView={1}
              modules={[Navigation]}
              className="FeaturesHighlightSwiper"
              navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
              }}
            >
              {highlights.map((highlight) => (
                <SwiperSlide className="FeaturesHighlightSwiperSlide">
                  <Card
                    className="FeaturesHighlightCard"
                    theme="Blue"
                    paddingSize="Double"
                  >
                    <Card.Title>{highlight.title}</Card.Title>
                    <Card.Content>
                      <SanityPortableText blocks={highlight.text} />
                      <div className="FeaturesHighlightStatsGrid">
                        {highlight.stats?.map((stat) => (
                          <div className="FeaturesHighlightStat">
                            <div className="FeaturesHighlightStatNumber">
                              {stat.number}
                            </div>
                            <div className="FeaturesHighlightStatText">
                              {stat.text}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Card.Content>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="FeaturesHighlightSwiperArrows">
              <button
                className="swiper-button-prev"
                aria-label="Previous slide"
              >
                <ArrowIcon />
              </button>
              <button className="swiper-button-next" aria-label="Next slide">
                <ArrowIcon />
              </button>
            </div>
          </>
        )}
      </div>
    </Pancake>
  );
};

const ArrowIcon = () => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68209 10.157L0.762558 3.23744L3.23744 0.762573L12.6318 10.157L3.23743 19.5513L0.762565 17.0765L7.68209 10.157Z"
      fill="currentColor"
    />
  </svg>
);

export const query = graphql`
  fragment SanityPancakeFeaturesHighlight on SanityFeaturesHighlight {
    _key
    _type
    _rawFeatures
    _rawHighlights
  }
`;

export default FeaturesHighlight;
